import { styled } from 'styled-components';
import { IArticleBox6, defaultParams } from './params';
import { IGlobaVariables } from '../../Layout/styles';

const Styles = styled.div<{
  theme?: IGlobaVariables;
  $config: IArticleBox6;
}>`
  .article-box {
    position: relative;
    width: 100%;
    height: 100%;
    border: ${({ $config: styles }) => styles.border};
    border-radius: ${({ $config: styles }) => styles.borderRadius};
    background: ${({ $config: styles }) => styles.backgroundColor};
    box-shadow: ${({ $config: styles }) => styles.boxShadow};
    padding: 0;

    &-image {
      position: relative;
      display: block;
      width: 100%;
      aspect-ratio: 225 / 160;
      border-radius: ${({ $config: styles }) => styles.borderRadius} ${({ $config: styles }) => styles.borderRadius} 0 0;
      overflow: hidden;
      &::before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 50%;
        background: linear-gradient(to top, ${({ $config: styles }) => styles.backgroundColor}, transparent 100%);
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &-content {
      position: relative;
      padding: 20px 25px 50px;
      word-break: break-word;
    }

    &-category {
      position: absolute;
      left: 0;
      top: 0;
      transform: translateY(-95%);
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 0 25px;
      color: ${({ $config: styles }) => styles.group_category.color};
      font-family: ${({ $config: styles }) => styles.group_category.fontFamily};
      font-weight: ${({ $config: styles }) => styles.group_category.fontWeight};
      font-size: ${({ $config: styles }) => styles.group_category.fontSize};
      line-height: ${({ $config: styles }) => styles.group_category.lineHeight};
      text-decoration: ${({ $config: styles }) => styles.group_category.textDecoration};
      margin-bottom: 12px;
      transition: all 0.2s ease-in;
      &:hover {
        color: ${({ $config: styles }) => styles.group_category.hover_color};
        text-decoration: ${({ $config: styles }) => styles.group_category.hover_textDecoration};
      }

      &.disabled {
        pointer-events: none;
        color: ${({ $config: styles }) => styles.group_category.group_category_disabled.color};
        text-decoration: ${({ $config: styles }) => styles.group_category.group_category_disabled.textDecoration};
      }
    }

    &-title {
      line-height: ${({ $config: styles }) => styles.group_title.lineHeight};

      a {
        color: ${({ $config: styles }) => styles.group_title.color};
        font-family: ${({ $config: styles }) => styles.group_title.fontFamily};
        font-style: ${({ $config: styles }) => styles.group_title.fontStyle};
        font-weight: ${({ $config: styles }) => styles.group_title.fontWeight};
        font-size: ${({ $config: styles }) => styles.group_title.fontSize};
        text-decoration: ${({ $config: styles }) => styles.group_title.textDecoration};

        &:hover {
          color: ${({ $config: styles }) => styles.group_title.hover_color};
          text-decoration: ${({ $config: styles }) => styles.group_title.hover_textDecoration};
        }
      }
    }

    &-description {
      color: ${({ $config: styles }) => styles.group_description.color};
      font-family: ${({ $config: styles }) => styles.group_description.fontFamily};
      font-weight: ${({ $config: styles }) => styles.group_description.fontWeight};
      font-size: ${({ $config: styles }) => styles.group_description.fontSize};
      line-height: ${({ $config: styles }) => styles.group_description.lineHeight};
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow-wrap: break-word;
      overflow: hidden;
      margin: 0;
    }

    &-button {
      position: absolute;
      bottom: -22.5px;
      left: calc(50% - 22.5px);
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 45px;
      height: 45px;
      background: ${({ $config: styles }) => styles.group_button.backgroundColor};
      border: ${({ $config: styles }) => styles.group_button.border};
      border-radius: 50%;
      color: ${({ $config: styles }) => styles.group_button.color};
      transition: 0.2s all ease-in;
      box-sizing: border-box;
      svg {
        width: 25px;
        height: 25px;
        transition: transform 0.2s ease-in;
      }
      &:hover {
        background: ${({ $config: styles }) => styles.group_button.hover_backgroundColor};
        border: ${({ $config: styles }) => styles.group_button.hover_border};
        color: ${({ $config: styles }) => styles.group_button.hover_color};
      }
    }
  }
`;

export default Styles;
